<template>
  <div>
    <div style="width:calc(100% - 310px); margin-left:0px; float:left">
      <div class="full-f-chart" style="height: calc(100vh - 204px);">
        <w-log-keyword-map ref="keyWord" :active="active" @wordCount="setWordCount"></w-log-keyword-map>
      </div>
    </div>
    <div style="width:310px; float:left;">
      <w-log-keyword-map-count class="full" style="height: calc(100vh - 215px); margin-left: -22px"
      @getHoverWord="getHoverWord"
      @clearWord="clearWord"
      @wordClick="wordClick"
      @groupCheck="groupCheck"
      :wordCount="wordCount"
      :checkGroupFlag="checkGroupFlag"
      :active="active"></w-log-keyword-map-count>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import WLogKeywordMap from './LogKeywordMap';
import WLogKeywordMapCount from './LogKeywordMapCount';

export default {
  name: 'WKeywordMap',
  components: {
    WLogKeywordMap,
    WLogKeywordMapCount,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      wordCount: [],
      checkGroupFlag: false,
    };
  },
  methods: {
    /**
     * 연관단어 테이블에서 row 클릭 시 선택한 단어를 keywordMap으로 보내준다
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    wordClick(data) {
      this.$refs.keyWord.wordClick(data);
    },
    /**
     * 연관단어 테이블에서 선택한 출력 그룹 목록을 keywordMap으로 보내준다.
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    groupCheck(data) {
      this.$refs.keyWord.groupCheck(data);
    },
    /**
     * 연관단어 테이블에서 row에 마우스 오버 시 해당하는 정보를 키워드맵에 보내 하이라이트 효과를 준다
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getHoverWord(data) {
      this.$refs.keyWord.getHoverWord(data);
    },
    /**
     * 마우스 오버 이벤트 해제 시 작동하는 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    clearWord() {
      this.$refs.keyWord.clearWord();
    },
    /**
     * 키워드 맵에서 조회한 데이터를 연관단어 테이블로 보내준다
     * @author leesy918
     * @param  {[type]} data [description]
     * @param  {[type]} flag [description]
     */
    setWordCount(data, flag) {
      this.checkGroupFlag = flag;
      this.wordCount = cloneDeep(data);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/KeywordMap/index.vue